export interface TeamStrengthsFitInput {
  width: number;
  height: number;
  count: number;
  longestNameRatio: number;
}

export interface TeamStrengthsFitResult {
  cols: number;
  cardWidth: number;
  photoHeight: number;
  fontSize: number;
  gap: number;
  scroll: boolean;
}

export const chooseTeamStrengthsFit = ({
  width,
  height,
  count,
  longestNameRatio,
}: TeamStrengthsFitInput): TeamStrengthsFitResult => {
  const safeCount = Math.max(0, count);
  const safeWidth = Math.max(0, width);
  const safeHeight = Math.max(0, height);
  const gap = safeWidth < 700 ? 8 : 12;
  const ratio = Math.max(longestNameRatio || 0, 1);
  let best: (TeamStrengthsFitResult & { score: number }) | null = null;

  for (let cols = 2; cols <= safeCount; cols += 1) {
    const rows = Math.ceil(safeCount / cols);
    const cardWidth = Math.floor((safeWidth - (cols - 1) * gap) / cols);
    const fontSize = Math.min(30, (cardWidth - 18) / ratio);
    if (fontSize < 12) continue;

    const cardHeight = (safeHeight - (rows - 1) * gap) / rows;
    const photoHeight = Math.min(cardWidth, cardHeight - fontSize * 1.3 - 18);
    if (photoHeight < cardWidth * 0.6) continue;

    const score = fontSize * 1000 + photoHeight;
    if (!best || score > best.score) {
      best = { cols, cardWidth, fontSize, photoHeight, gap, scroll: false, score };
    }
  }

  if (best) {
    const { score: _score, ...result } = best;
    return result;
  }

  const cols = safeWidth < 420 ? 2 : 3;
  const cardWidth = Math.floor((safeWidth - (cols - 1) * gap) / cols);

  return {
    cols,
    cardWidth,
    photoHeight: cardWidth * 0.9,
    fontSize: Math.max(12, Math.min(20, (cardWidth - 18) / ratio)),
    gap,
    scroll: true,
  };
};
